<template>
  <div class="container lg:w-3/12 bg-gray-100 pb-4 pt-5 p-4">
    <router-link type="button" class="hover:underline block text-left" to="/">
      <svg class="h-8 w-8 fill-current text-blue-900" xmlns="http://www.w3.org/2000/svg"
        viewBox="274.835 394.86 54.965 55.15">
        <defs />
        <path
          d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z" />
      </svg>
    </router-link>
    <div class="shadow-2xl bg-white p-4">
      <LoginComponent label_login_user="Usuario:" label_login_password="Contraseña:"
        :view_class_view="view_class_view" :validations="rulevalidations" v-on:LogIn="log_in($event)"
         v-on:keypress.enter="log_in($event)" :showRecoverPassword="false" >
      </LoginComponent>
    </div>
  </div>
</template>

<script>
import { email, helpers, requiredIf } from "@vuelidate/validators";
import { ref } from "vue";
import Swal from "sweetalert2";
import axios from "axios";
import { useRouter } from 'vue-router';

export default {
  setup() {
    const router = useRouter();
    let ccAPI = process.env.VUE_APP_CCAPI;
    let view_class_view = {
      header_title: "py-5 header-title text-gray-900 text-center text-3xl mb-0 mt-4",
      classInputs: {
        valid: " border-blue-600",
        no_valid: "border-red-600",
        default: "shadow-md border-2 rounded-lg py-3 w-full px-3 mb-5",
      },
      div_content_recovery: "mt-10 text-center",
      div_content_button_login: "mt-10 w-full sm:text-center",
      button_log_in: "w-full py-3 px-4 bg-main_button_color text-white w-full md:w-2/5 mt-3  justify-center  bg-orange-600 hover:bg-orange-700 text-white font-bold py-2 rounded",
      button_text: "Iniciar sesión",
      div_container_error: {
        container: "mt-2 mb-2",
        text_error: "text-red-600",
      },
    };

    let rulevalidations = ref({
      email: {
        required: helpers.withMessage(
          "El correo electrónico es requerido.",
          requiredIf(true)
        ),
        email: helpers.withMessage(
          "El correo ingresado no es valido, ejemplo de formato (Juanperez@gmail.com).",
          email
        ),
      },
      password: {
        required: helpers.withMessage(
          "El campo contraseña es requerido.",
          requiredIf(true)
        ),
      },
    });

    async function log_in(userModel) {

      if (!userModel) {
        swal_fire("warning","Cuidado!!","Campos invalidos.");
        return false;
      }else{
        let config = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        let data = {
          account: {
            email: userModel.value.email,
            password: userModel.value.password,
          },
        };
        await axios.post(ccAPI + "/lm/accounts/login", data, config).then((api_reponse) => {
          console.log("repuesta: ", api_reponse);
          if (api_reponse.status == 200 && api_reponse.data.response.message == "Se logio correctamente") {
            sessionStorage.setItem("token_auth", api_reponse.data.response.token_auth)
            router.push({ name: "digital-sales-report" });
          }else{
            swal_fire("warning","Cuidado!!",api_reponse.data.response.message);
          }
      });
      }

    }

    function swal_fire(icon, title, message){
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
      });
    }

    return {
      view_class_view,
      rulevalidations,
      log_in,
      swal_fire,
    }
  }
}

</script>